import { useQuery } from '@tanstack/react-query';

import { getOrdersByIds } from '~/services/OrdersService';

const ORDERS_BY_IDS_CHUNK_SIZE = 100;

export const ordersByIdsQueryKeys = {
  all: ['ordersByIds'] as const,
  lists: () => [...ordersByIdsQueryKeys.all, 'list'] as const,
  list: (orderIds: Array<string>, brand: string) => [...ordersByIdsQueryKeys.lists(), brand, orderIds] as const,
};

function getUniqueOrderIds(orderIds: Array<string>): Array<string> {
  return Array.from(new Set(orderIds.filter(Boolean))).sort();
}

async function getOrdersByIdsInChunks(orderIds: Array<string>, brand: string) {
  const orderChunks = [];

  for (let index = 0; index < orderIds.length; index += ORDERS_BY_IDS_CHUNK_SIZE) {
    orderChunks.push(orderIds.slice(index, index + ORDERS_BY_IDS_CHUNK_SIZE));
  }

  const orderResponses = await Promise.all(orderChunks.map((orderChunk) => getOrdersByIds(orderChunk, brand)));

  return orderResponses.flat();
}

export function useGetOrdersByIds(orderIds: Array<string>, brand: string, enabled = true) {
  const uniqueOrderIds = getUniqueOrderIds(orderIds);

  return useQuery({
    queryKey: ordersByIdsQueryKeys.list(uniqueOrderIds, brand),
    queryFn: async () => getOrdersByIdsInChunks(uniqueOrderIds, brand),
    enabled: enabled && uniqueOrderIds.length > 0 && Boolean(brand.trim()),
    staleTime: 60_000,
  });
}
